import "./layout.css";

import React  from "react";
import { Layout } from "antd";
import Media from "react-media";

import { Header } from "./components/Header";
import { Sidebar } from "./components/Sidebar";
import { SwitchRoutes } from "../routes/SwitchRoutes";
import { getAllowedRoutes } from "../routes";
import { useLocation } from "react-router";
import { isHeaderAndSidebarHidden } from "./utils/hiddenSidebar";
import { useContext } from "react";
import { UserContext } from "../contexts/userContext";

export const AppLayout = () => {
  const role = localStorage.getItem("role") 
  const location = useLocation();
  const isSidebarVisible = !isHeaderAndSidebarHidden(location);
  const { userInfo } = useContext(UserContext);

  return (
    <Layout
      style={{ minHeight: "100vh", zIndex: "2", backgroundColor: "#f7f8f9" }}
    >
      {isSidebarVisible && (
        <Media query="(max-width: 599px)">
          {(matches) => (
            <Sidebar permission={role} isSmallScreen={matches} currentPage={location.pathname} />
          )}
        </Media>
      )}
      <Layout>
        {isSidebarVisible && <Header />}
        <Layout.Content>
          <div
            style={{
              padding: isSidebarVisible ? 24 : 0,
              background: "#f7f8f9",
              minHeight: "100vh",
            }}
          >
            <SwitchRoutes routes={getAllowedRoutes(userInfo.type)} />
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
};
